import React from "react";

import { NEWSLETTER_EXCLUDED_PAGES } from "utils/constants";
import { AppArticle } from "utils/orm";
import { Newsletter } from "./Newsletter";

/* eslint-disable @typescript-eslint/no-unused-vars */
const EmailCapture = (props: AppArticle) => {
    const {
        slug,
        templateName,
    } = props;
    const [emailCaptureReady, setEmailCaptureReady] = React.useState(false);
    const [showNewsletter, setShowNewsletter] = React.useState(false);

    const shouldNewsletterShow = () => {
        switch (templateName) {
        case "companyLanding": {
            return true;
        }
        case "landing":
        case "listicle":
        case "article": {
            // check slugs
            if (NEWSLETTER_EXCLUDED_PAGES.some((x) => x === slug)) {
                return false;
            }
            break;
        }
        default: {
            break;
        }
        }
        return true;
    };

    React.useEffect(() => {
        setShowNewsletter(shouldNewsletterShow());
        setEmailCaptureReady(true);
    }, []);

    if (!emailCaptureReady) {
        return null;
    }

    if (showNewsletter) {
        return <Newsletter />;
    }

    return null;
};

export { EmailCapture };
